import IMCategories from './IMCategoriesList';

export default IMCategories;
